import { type FC, useState } from "react";

import { Column, EmptyState, HtImage } from "@hightouch/htui";

import {
  AnalyticsGraph,
  type AnalyticsGraphProps,
} from "src/components/charts/engine/analytics-graph";
import analyticsPlaceholder from "src/assets/placeholders/goals.svg";
import { ChartErrorState } from "src/components/charts/chart-error-state";

export const DEFAULT_CHART_HEIGHT = "400px";

export type ChartProps = AnalyticsGraphProps & {
  isLoading?: boolean;
  isPlaceholder?: boolean;
  isError?: boolean;
  emptyDataText?: string;
};

export const Chart: FC<ChartProps> = ({
  isLoading = false,
  isPlaceholder = false,
  isError = false,
  height = DEFAULT_CHART_HEIGHT,
  emptyDataText = "No data to display",
  ...props
}) => {
  const [hoveredLine, setHoveredLine] = useState<string>();
  if (isPlaceholder) {
    return (
      <Column align="center" justify="center" minHeight={height} pos="relative">
        <HtImage src={analyticsPlaceholder} alt="Chart placeholder." h="100%" />
      </Column>
    );
  }

  if (!isLoading && isError) {
    return <ChartErrorState minHeight={height} />;
  }
  if (!isLoading && props.graphSeries.length === 0) {
    return (
      <Column align="center" justify="center" minHeight={height}>
        <EmptyState
          variant="minimal"
          imageUrl={analyticsPlaceholder}
          message={emptyDataText}
        />
      </Column>
    );
  }
  return (
    <AnalyticsGraph
      {...props}
      isLoading={isLoading}
      height={height}
      hoveredLine={hoveredLine}
      onHoverLine={setHoveredLine}
    />
  );
};
